import styles from './button.module.css';

export const Button = ({
  type = 'button',
  variant = 'primary',
  loading,
  className = '',
  children,
  ...props
}) => (
  <button
    type={type}
    className={`${styles.button} ${className} ${[styles[variant]]}`}
    disabled={loading}
    {...props}
  >
    {loading ? 'loading' : children}
  </button>
);
